export const eventTypes = { arrival: 'ARRIVAL', departure: 'DEPARTURE', }
